import React from "react";
import CategoryProductList from "./CategoryProductList";

const BrakeParts = () => {
  return (
    <CategoryProductList
      categoryName="Brake System"
      categorySlug="brakes"
    />
  );
};

export default BrakeParts;
